var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.09 7.32776H0.658203V21.9701H5.09V7.32776Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87404 5.40914C3.39835 5.41398 3.91225 5.25948 4.3505 4.96525C4.78876 4.67102 5.1316 4.25032 5.33553 3.75656C5.53947 3.2628 5.5953 2.71824 5.49592 2.192C5.39654 1.66575 5.14643 1.18156 4.77735 0.800861C4.40828 0.420166 3.93688 0.160138 3.42298 0.0537846C2.90908 -0.0525685 2.37585 -0.000450764 1.89098 0.203518C1.4061 0.407488 0.991439 0.754116 0.699629 1.1994C0.407819 1.64469 0.252002 2.16855 0.25198 2.70451C0.250408 3.05808 0.316987 3.40851 0.447908 3.73579C0.578828 4.06306 0.771538 4.36078 1.01502 4.61192C1.2585 4.86307 1.54798 5.06274 1.86695 5.19952C2.18593 5.33631 2.52814 5.40754 2.87404 5.40914Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.173 14.282C12.173 12.2242 13.1048 10.9969 14.8787 10.9969C16.5092 10.9969 17.2678 12.1754 17.2678 14.282V21.9634H21.6757V12.6944C21.6757 8.77432 19.5016 6.87534 16.4674 6.87534C15.6023 6.86512 14.7495 7.08486 13.9925 7.51302C13.2354 7.94118 12.6002 8.56308 12.1491 9.31776V7.34551H7.89648V22H12.1491L12.173 14.282Z",
    fill: "#263238"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.344e95d81b1b5c8808d4b909588be15c.svg";
export { ForwardRef as ReactComponent };